import { addViewItemList } from "@/lib/gtm";
import { SearchIcon } from "@chakra-ui/icons";
import {
  Box,
  Flex,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useToast
} from "@chakra-ui/react";
import Router from "next/router";
import { useEffect, useRef, useState } from "react";
import { BsSearch } from "react-icons/bs";
import { SmartSearch } from "../SmartSearch";

type SearchProps = {
  loadingAnim?: any;
};

export function FreeSearchDesktop({ loadingAnim }: SearchProps) {
  const [SearchTerm, setSearchTerm] = useState<string>("");
  const FreeSearchInputRef = useRef<HTMLInputElement>(null);
  const CloseButtonRef = useRef<HTMLButtonElement>(null);
  const Toast = useToast({
    position: "bottom"
  });
  async function SubmitFreeSearch() {
    if (SearchTerm) {
      handleViewItemList();

      if (Router.pathname === "/pesquisa/[Search]") {
        Router.push(`/pesquisa/${encodeURIComponent(SearchTerm)}`, null, {
          shallow: true
        });
      } else {
        Router.push(`/pesquisa/${encodeURIComponent(SearchTerm)}`);
      }
      setSearchTerm("");
    } else {
      Toast({
        title: "Digite um termo para pesquisar.",
        status: "info",
        position: "bottom",
        duration: 5000,
        isClosable: true
      });
    }
  }

  function handleViewItemList() {
    const searchTerm = SearchTerm;

    loadingAnim(true);

    addViewItemList(searchTerm);
  }

  return (
    <Box mr="10px">
      <Text textStyle="Regular" color={"ll-gray.500"} mb={"8px"}>
        Busca inteligente de pneus por:
      </Text>
      <SmartSearch
        Search={SearchTerm}
        setSearch={setSearchTerm}
        initialFocusRef={FreeSearchInputRef}
        closeButtonRef={CloseButtonRef}
      >
        <Flex
          onClickCapture={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          paddingY={"4"}
          paddingLeft={"4"}
          alignSelf={"center"}
          alignItems={"center"}
          justify={"space-between"}
          color={"gray.200"}
          position={"relative"}
          bg={"white"}
          h={"40px"}
          borderRadius={"50px"}
          borderWidth="1px"
          borderColor="ll-gray.100"
          bgColor={"ll-gray.600"}
        >
          <Input
            placeholder={"DIGITE A MEDIDA, MARCA OU MODELO"}
            color={"ll-gray.200"}
            bgColor={"transparent"}
            width={"340px"}
            fontSize={"text1"}
            variant={"unstyled"}
            _placeholder={{ color: "#58585A" }}
            value={SearchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onBlur={(e) => {
              let target = e?.relatedTarget;
              if (target?.getAttribute("role") !== "tab") {
                CloseButtonRef?.current?.click();
                FreeSearchInputRef.current.value = "";
              }
            }}
            onKeyUp={(e) => {
              if (e.key === "Escape") {
                CloseButtonRef?.current?.click();
                setSearchTerm(null);
              }
              if (e.key === "Enter") {
                SubmitFreeSearch();
              }
            }}
            ref={FreeSearchInputRef}
          />
        </Flex>
      </SmartSearch>
    </Box>
  );
}

export function FreeSearchMobile() {
  const [SearchTerm, setSearchTerm] = useState<string>("");
  const FreeSearchInputRef = useRef<HTMLInputElement>(null);
  const CloseButtonRef = useRef<HTMLButtonElement>(null);
  const Toast = useToast({
    position: "bottom"
  });
  async function submitFreeSearch() {
    if (SearchTerm) {
      if (Router.pathname === "/pesquisa/[Search]") {
        Router.push(`/pesquisa/${encodeURIComponent(SearchTerm)}`, null, {
          shallow: true
        });
      } else {
        Router.push(`/pesquisa/${encodeURIComponent(SearchTerm)}`);
      }
      setSearchTerm("");
    } else {
      Toast({
        title: "Digite um termo para pesquisar.",
        status: "info",
        position: "bottom",
        duration: 5000,
        isClosable: true
      });
    }
  }

  return (
    <>
      <Text textStyle="Regular" color="#58585A" mb={"1px"}>
        Busca inteligente por:
      </Text>
      <SmartSearch
        Search={SearchTerm}
        setSearch={setSearchTerm}
        initialFocusRef={FreeSearchInputRef}
        closeButtonRef={CloseButtonRef}
      >
        <Flex
          w="full"
          onClickCapture={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          height="auto"
          justifyContent="center"
          alignItems="center"
          pb={"10px"}
          pt={"10px"}
        >
          <InputGroup>
            <InputRightElement
              mt="4px"
              onClick={submitFreeSearch}
              pointerEvents="none"
              children={<BsSearch color="#A9A9A9" />}
              _focus={{ borderColor: "red" }}
            />
            <Input
              h="40px"
              _placeholder={{ color: "#A9A9A9" }}
              borderColor="#ABB4BD"
              _focus={{ borderColor: "#A9A9A9", boxShadow: "none" }}
              value={SearchTerm}
              onKeyUp={(e) => {
                if (e.key === "Escape") {
                  // CloseButtonRef?.current?.click();
                  setSearchTerm(null);
                }
                if (e.key === "Enter") {
                  submitFreeSearch();
                }
              }}
              onBlur={(e) => {
                let target = e?.relatedTarget;
                if (target?.getAttribute("role") !== "tab") {
                  // CloseButtonRef?.current?.click();
                  FreeSearchInputRef.current.value = "";
                }
              }}
              onChange={(e) => setSearchTerm(e.target.value)}
              fontSize={"16px"}
              placeholder="Medida ou modelo de pneu..."
              borderRadius="50px"
              ref={FreeSearchInputRef}
            />
          </InputGroup>
        </Flex>
      </SmartSearch>
    </>
  );
}

export function FreeSearchMobileToHeader() {
  const [SearchTerm, setSearchTerm] = useState<string>("");
  const FreeSearchInputRef = useRef<HTMLInputElement>(null);
  const CloseButtonRef = useRef<HTMLButtonElement>(null);
  const Toast = useToast({
    position: "bottom"
  });
  async function submitFreeSearch() {
    if (SearchTerm) {
      if (Router.pathname === "/pesquisa/[Search]") {
        Router.push(`/pesquisa/${encodeURIComponent(SearchTerm)}`, null, {
          shallow: true
        });
      } else {
        Router.push(`/pesquisa/${encodeURIComponent(SearchTerm)}`);
      }
      setSearchTerm("");
    } else {
      Toast({
        title: "Digite um termo para pesquisar.",
        status: "info",
        position: "bottom",
        duration: 5000,
        isClosable: true
      });
    }
  }

  return (
    <SmartSearch
      Search={SearchTerm}
      setSearch={setSearchTerm}
      initialFocusRef={FreeSearchInputRef}
      closeButtonRef={CloseButtonRef}
      customW={"100%"}
    >
      <Flex
        w={"full"}
        onClickCapture={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        backgroundColor="white"
        height="auto"
        justifyContent="center"
        alignItems="center"
        px={"15px"}
      >
        <Flex
          as="label"
          paddingLeft="6"
          alignSelf="center"
          alignItems="center"
          justify="space-between"
          color="gray.200"
          position="relative"
          bg="white"
          w="100%"
          h="40px"
          direction="row"
          borderRadius={"50px"}
          border={"1px solid #A9A9A9"}
        >
          <Input
            value={SearchTerm}
            onKeyUp={(e) => {
              if (e.key === "Escape") {
                CloseButtonRef?.current?.click();
                setSearchTerm(null);
              }
              if (e.key === "Enter") {
                submitFreeSearch();
              }
            }}
            onBlur={(e) => {
              let target = e?.relatedTarget;
              if (target?.getAttribute("role") !== "tab") {
                CloseButtonRef?.current?.click();
                FreeSearchInputRef.current.value = "";
              }
            }}
            onChange={(e) => setSearchTerm(e.target.value)}
            type="text"
            name="searchBox"
            textTransform="uppercase"
            fontSize="16px"
            placeholder="pesquise por pneus ou medidas"
            _placeholder={{ color: "gray.300", fontSize: "12px" }}
            _focus={{ borderColor: "yellow.900" }}
            borderColor="transparent"
            focusBorderColor="gray.800"
            borderRadius="0"
            backgroundColor="white"
            width="80%"
            variant="unstyled"
            bg="white"
            color="gray.700"
            ref={FreeSearchInputRef}
          />
          <IconButton
            type="button"
            variant="unstyled"
            onClick={submitFreeSearch}
            colorScheme="blue"
            aria-label="Pesquise"
            _focus={{ border: "none", boxShadow: "none" }}
            icon={<SearchIcon mr="15px" fontSize="20px" color="blue.1000" />}
          />
        </Flex>
      </Flex>
    </SmartSearch>
  );
}
